import { AddToBasket } from '@virginexperiencedays/components-v2/src/pages/product/AddToBasket/v2';
import type { AddToBasketProps } from '@virginexperiencedays/components-v2/src/pages/product/AddToBasket';

export type AddToBasketWidgetProps = Omit<AddToBasketProps, 'disabled'> & {
  outOfStock: boolean;
  isActive: boolean;
};

export const AddToBasketWidget = ({
  className,
  isActive,
  outOfStock,
  error,
  onClick,
}: AddToBasketWidgetProps) => (
  <AddToBasket
    onClick={onClick}
    disabled={outOfStock || !isActive}
    error={error}
    className={className}
  />
);
